<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{ roleid == 9 ? "Department of Clinic" : "Clinic Branch" }}
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 9 || roleid == 10">
        <b-tab-item label="ຜະລິດຕາມຕາມສັນຍາ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຜະລິດຕາມຕາມສັນຍາ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="30%">
                        ແຂວງ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ລໍຖ້າແກ້ໄຂ
                      </th>
                      <th class="has-text-centered " width="20%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketList" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>

                      <td class="has-text-centered">
                        {{ data.ISSUEWAIT }}
                      </td>

                      <td class="has-text-centered">
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              getMarketProductionFarmerList(
                                data.PROVINCEID,
                                data.PROVINCENAME
                              )
                            "
                            >ລາຍລະອຽດ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ລາຍລະອຽດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="selectedMarketName">
                <b-tabs v-model="activeSubTab">
                  <b-tab-item label="ຊາວກະສິກອນ ທີ່ມີບັນຫາ">
                    <div class="columns scrollme">
                      <div class="column">
                        <b-field>
                          <table class="table is-fullwidth is-narrow is-small">
                            <thead>
                              <tr>
                                <th class="has-text-centered " width="5%">#</th>
                                <th class="has-text-left " width="15%">
                                  ຊາວກະສິກອນ/ ຟາມ
                                </th>
                                <th class="has-text-centered" width="15%">
                                  ລໍຖ້າແກ້ໄຂ
                                </th>
                                <th class="has-text-centered" width="20%">
                                  ຈັດການ
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in marketFarmerList"
                                :key="data.FARMID"
                              >
                                <td class="has-text-centered">
                                  {{ index + 1 }}
                                </td>
                                <td>
                                  {{ data.FARMERNAME }}
                                </td>
                                <td class="has-text-centered">
                                  {{ data.ISSUEWAIT }}
                                </td>
                                <td class="has-text-centered">
                                  <b-field>
                                    <b-button
                                      class="btn-group-margin"
                                      type="is-primary"
                                      size="is-small"
                                      @click="
                                        getProductionReport(data.PRODUCTIONID)
                                      "
                                      >ລາຍລະອຽດ
                                    </b-button>
                                  </b-field>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-field>
                      </div>
                    </div>
                  </b-tab-item>
                  <b-tab-item label="ລາຍລະອຽດບັນຫາ">
                    <div class="columns scrollme">
                      <div class="column">
                        <b-field>
                          <!-- <table class="table is-fullwidth is-narrow is-small">
                            <tr>
                              <td width="40%">

                                <div class="has-text-left">
                                <div class="text-highlight">ຄຳແນະນຳ</div> <br>
                              </div>
                              <div>
                                 <b-input maxlength="200" v-model.trim="productionReportDetail"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                                <b-field grouped position="is-right">
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-primary"
                                    @click="
                                      productionClinicAdvice()
                                    "
                                    >ຄຳແນະນຳ
                                  </b-button>
                                </b-field>
                              </div>
                                
                              
                                
                              </td>
                              <td width="60%">
                                <div>
                                  <table class="table is-fullwidth is-narrow is-small">
                                    <thead>
                                      <tr>
                                        <th class="has-text-left " >
                                          ບັນຫາ ແລະ ຄຳແນະນຳ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(data) in productionReportList" :key="data.ID">
                                        <td> 
                                          <div class="container">
                                            <div class="columns">
                                              <div class="column">
                                                <div class="issue-date"><b-field v-if="data.ISFARMER==1">{{ data.ISSUEDATE }} {{ data.ISSUETIME }}</b-field></div>
                                            
                                                <div><b-field v-if="data.ISFARMER==1">{{ data.ISSUE }}</b-field></div>
                                              </div>
                                              <div class="column">
                                                <div class="issue-date issue-response"><b-field v-if="data.ISFARMER!=1">{{ data.ISSUEDATE }} {{ data.ISSUETIME }}</b-field></div>
                                            
                                                <div class="issue-response"><b-field v-if="data.ISFARMER!=1">{{ data.RESPONSE }}</b-field></div>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr> 
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </table> -->
                          <table class="table is-fullwidth">
                            <tr>
                              <td width="30%" class="has-text-right">
                                <div class="has-text-left">
                                  <div class="text-highlight">
                                    ບັນຫາການຜະລິດ
                                  </div>
                                  <br />
                                </div>
                                <div>
                                  <table class="table is-fullwidth ">
                                    <tr>
                                      <th
                                        class="has-text-right "
                                        width="50%"
                                      ></th>
                                      <th
                                        class="has-text-left "
                                        width="50%"
                                      ></th>
                                    </tr>

                                    <tbody>
                                      <tr>
                                        <td class="has-text-right">
                                          ສິນຄ້າ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight"
                                            >{{ farmerProductionProductname }}
                                            {{ farmerProductionAmount }} </span
                                          >/ {{ farmerProductionTotalAmount }}
                                          {{ farmerProductionUnit }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="has-text-right">
                                          ເກັບຜົນຜະລິດຕາມແຜນ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight">{{
                                            farmerProductionRedate
                                          }}</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="has-text-right">
                                          ວັນທີແນະນຳຜະລິດ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight">{{
                                            farmerProductionRecommentdate
                                          }}</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="has-text-right">
                                          ວັນທີຜະລິດຕົວຈິງ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight">{{
                                            farmerProductionProdate
                                          }}</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="has-text-right">
                                          ຈຳນວນທີ່ຜະລິດຕົວຈິງ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight"
                                            >{{ farmerProductionProamount }}
                                          </span>
                                          <span
                                            v-if="farmerProductionProamount"
                                            >{{ farmerProductionUnit }}</span
                                          >
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="has-text-right">
                                          ວັນທີເກັບກ່ຽວຕົວຈິງ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight">{{
                                            farmerProductionHarvestdate
                                          }}</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="has-text-right">
                                          ຜົນຜະລິດຕົວຈິງ:
                                        </td>
                                        <td class="has-text-left">
                                          <span class="text-highlight"
                                            >{{ farmerProductionHarvestamount }}
                                          </span>
                                          <span
                                            v-if="farmerProductionHarvestamount"
                                            >{{ farmerProductionUnit }}</span
                                          >
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                              <td width="5%"></td>
                              <td width="65%">
                                <div class="has-text-left" v-if="roleid == 10">
                                  <div class="text-highlight">ຄຳແນະນຳ</div>
                                  <br />
                                </div>
                                <div v-if="roleid == 10">
                                  <b-input
                                    maxlength="200"
                                    v-model.trim="productionReportDetail"
                                    type="textarea"
                                    placeholder="ລາຍລະອຽດ"
                                  ></b-input>
                                  <b-field grouped position="is-right">
                                    <b-button
                                      class="btn-group-margin"
                                      type="is-primary"
                                      @click="productionClinicAdvice()"
                                      >ຄຳແນະນຳ
                                    </b-button>
                                  </b-field>
                                </div>

                                <div>
                                  <table
                                    class="table is-fullwidth is-narrow is-small"
                                  >
                                    <thead>
                                      <tr>
                                        <th class="has-text-left ">
                                          ບັນຫາ ແລະ ຄຳແນະນຳ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="data in productionReportList"
                                        :key="data.ID"
                                      >
                                        <td>
                                          <div class="container">
                                            <div class="columns">
                                              <div class="column">
                                                <div class="issue-date">
                                                  <b-field
                                                    v-if="data.ISFARMER == 1"
                                                    >{{ data.ISSUEDATE }}
                                                    {{
                                                      data.ISSUETIME
                                                    }}</b-field
                                                  >
                                                </div>

                                                <div>
                                                  <b-field
                                                    v-if="data.ISFARMER == 1"
                                                    >{{ data.ISSUE }}</b-field
                                                  >
                                                </div>
                                              </div>
                                              <div class="column">
                                                <div
                                                  class="issue-date issue-response"
                                                >
                                                  <b-field
                                                    v-if="data.ISFARMER != 1"
                                                    >{{ data.ISSUEDATE }}
                                                    {{
                                                      data.ISSUETIME
                                                    }}</b-field
                                                  >
                                                </div>

                                                <div class="issue-response">
                                                  <b-field
                                                    v-if="data.ISFARMER != 1"
                                                    >{{
                                                      data.RESPONSE
                                                    }}</b-field
                                                  >
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </b-field>
                      </div>
                    </div>
                  </b-tab-item>
                </b-tabs>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,

      activeTab: 0,
      marketList: [],

      activeSubTab: 0,

      selectedMarketID: null,
      selectedMarketName: null,
      marketFarmerList: [],

      productionReportList: [],
      productionReportDetail: null,
      selectedProductionid: null,

      farmerProductionFarmername: null,
      farmerProductionRequestID: null,
      farmerProductionRedate: null,
      farmerProductionGetplandate: null,
      farmerProductionID: null,
      farmerProductionFarmID: null,
      farmerProductionFarmerID: null,
      farmerProductionTotalAmount: null,
      farmerProductionProductid: null,
      farmerProductionProductname: null,
      farmerProductionUnit: null,
      farmerProductionAmount: null,
      farmerProductionRecommentdate: null,
      farmerProductionProdate: null,
      farmerProductionProamount: null,
      farmerProductionHarvestdate: null,
      farmerProductionHarvestamount: null,
      farmerProductionProstatus: null,
    };
  },
  methods: {
    getMarketProductionReport() {
      console.log("this.userProvinceID-: " + this.userProvinceID);
      RestAPI.getB2BProductionReport(this.userProvinceID)
        .then((res) => {
          console.log("list:" + JSON.stringify(res.data));
          this.marketList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getMarketProductionFarmerList(ID, NAME) {
      this.selectedMarketID = ID;
      this.selectedMarketName = NAME;
      console.log("ID:" + ID);
      this.activeTab = 1;
      this.activeSubTab = 0;
      RestAPI.getB2BProductionFarmerList(ID)
        .then((res) => {
          console.log("list:" + JSON.stringify(res.data));
          this.marketFarmerList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getProductionReport(productionid) {
      this.activeSubTab = 1;
      RestAPI.getProductionReport(productionid)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionReportList = res.data;
          this.selectedProductionid = productionid;
          this.farmerProduction(productionid);
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    productionClinicAdvice() {
      if (
        this.productionReportDetail === null ||
        this.productionReportDetail == " "
      ) {
        this.$swal("ກະລູນາ ລະບຸຄຳແນະນຳ", "", "error");
      } else {
        // this.selectedProductionid
        // console.log("productionReport: " + this.productionReportDetail);

        var params = {
          productionid: this.selectedProductionid,
          detail: this.productionReportDetail,
          username: this.username,
        };
        // console.log("params :" + JSON.stringify(params))
        RestAPI.productionClinicAdvice(params)
          .then(() => {
            this.getProductionReport(this.selectedProductionid);
            this.productionReportDetail = null;
            this.getMarketProductionReport();
            // this.getMarketProductionFarmerList(this.selectedMarketID, this.selectedMarketName)

            this.$swal("ສຳເລັດ !", "", "success");
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    farmerProduction(productionid) {
      RestAPI.getfarmerProduction(productionid)
        .then((res) => {
          this.farmerProductionFarmername = res.data[0].FARMERNAME;
          this.farmerProductionRequestID = res.data[0].MARKETREQUESTID;
          this.farmerProductionID = res.data[0].PROID;
          this.farmerProductionRedate = res.data[0].REDATE;
          this.farmerProductionGetplandate = res.data[0].GETPLANDATE;
          this.farmerProductionFarmID = res.data[0].FARMID;
          this.farmerProductionFarmerID = res.data[0].FARMERID;
          this.farmerProductionTotalAmount = res.data[0].TOTALAMOUNT;
          this.farmerProductionProductid = res.data[0].PRODUCTID;
          this.farmerProductionProductname = res.data[0].PRODUCTNAME;
          this.farmerProductionUnit = res.data[0].UNIT;
          this.farmerProductionAmount = res.data[0].AMOUNT;
          this.farmerProductionRecommentdate = res.data[0].RECOMMENTPRODUCEDATE;
          this.farmerProductionProdate = res.data[0].PRODUCEDATE;
          this.farmerProductionProamount = res.data[0].PRODUCEAMOUNT;
          this.farmerProductionHarvestdate = res.data[0].HARVESTDATE;
          this.farmerProductionHarvestamount = res.data[0].HARVESTAMOUNT;
          this.farmerProductionProstatus = res.data[0].PROSTATUS;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    console.log("this.user: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.CLPROVINCEID
      ? this.user.CLPROVINCEID
      : "all";
    this.selecteddate = new Date();
    this.formdate = new Date();
    // this.type = this.roleid == 9 ? "all" : "";
    this.getMarketProductionReport();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
